import React from 'react';
import PropTypes from 'prop-types';
import './css/customTooltip.css';

const CustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
        const { name, value, color } = payload[0]?.payload || {};
        return (
            <div 
                className="tooltip"
                style={{ '--tooltip-color': color }}
            >
                <strong>{name}:</strong> {value}
            </div>
        );
    }
    return null;
};


CustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.arrayOf(
        PropTypes.shape({
            payload: PropTypes.shape({
                name: PropTypes.string.isRequired,
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                color: PropTypes.string.isRequired,
            }).isRequired,
        })
    ),
};

export default CustomTooltip;
